// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Demo from './pages/Demo';
import ScrollToTop from './components/ScrollTop';
import ForIndependentPractices from './pages/ForIndependentPractices';
import ForNewPractices from './pages/ForNewPractices';
import ForConsultantPhysicians from './pages/ForConsultantPhysicians';
import ForGeneralPractitioners from './pages/ForGeneralPractitioners';
import ForDermatologists from './pages/ForDermatologists';
import ForPatients from './pages/ForPatients';
import ForCA from './pages/ForCA';
import EMR from './pages/EMR';
import DigitalFootprint from './pages/DigitalFootprint';
import DigitalOutreach from './pages/DigitalOutreach';
import BillingAndPayments from './pages/BillingAndPayments';
import DataAndInsights from './pages/DataAndInsights';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';



const App = () => {
  return (
    <Router>
      <div className="App">
        {/* Define routes for different pages */}
        <ScrollToTop></ScrollToTop>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/for-independent-practices" element={<ForIndependentPractices />} />
          <Route path="/for-new-practices" element={<ForNewPractices />} />
          <Route path="/for-consultant-physicians" element={<ForConsultantPhysicians />} />
          <Route path="/for-general-practitioners" element={<ForGeneralPractitioners />} />
          <Route path="/for-dermatologists" element={<ForDermatologists />} />
          <Route path="/for-patients" element={<ForPatients />} />
          <Route path="/for-ca" element={<ForCA />} />
          <Route path="/emr" element={<EMR />} />
          <Route path="/digital-footprint" element={<DigitalFootprint />} />
          <Route path="/digital-outreach" element={<DigitalOutreach />} />
          <Route path="/billing-and-payments" element={<BillingAndPayments />} />
          <Route path="/data-and-insights" element={<DataAndInsights />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
